import Swiper from 'swiper/swiper-bundle.mjs';
import domContentLoaded from 'utils/domContentLoaded';

domContentLoaded(() => {
  /**
   * Init Swiper for Hero slider
   */
  document.querySelectorAll('.js-swiper-pe-hero').forEach((carousel) => {
    const swiperConfig = {
      loop: true,
      effect: 'fade',
      spaceBetween: 30,
      autoplay: true,
    };

    /* eslint-disable no-unused-vars */
    const swiper = new Swiper(carousel, swiperConfig);
  });

  /**
   * Init Swiper for SIPs
   */
  document.querySelectorAll('.js-pe-pwa-swiper').forEach((carousel) => {
    const slideCount = carousel.querySelectorAll('.swiper-slide').length;

    const swiperConfig = {
      loop: true,
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      coverflowEffect: {
        rotate: 10,
        stretch: 1,
        depth: 600,
        scale: 0.9,
        modifier: 0.6,
        slideShadows: true,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: carousel.parentElement.parentElement.querySelector('.swiper-button-next'),
        prevEl: carousel.parentElement.parentElement.querySelector('.swiper-button-prev'),
      },
    };

    // Custom configuration if slider has less than 4 slides
    if (4 > slideCount) {
      swiperConfig.loop = false;
      swiperConfig.initialSlide = 1;
    }

    /* eslint-disable no-unused-vars */
    const swiper = new Swiper(carousel, swiperConfig);
  });

  /**
   * Init Swiper for related SIPs ('You May Also Like' section)
   */
  document.querySelectorAll('.js-pe-related-sip').forEach((carousel) => {
    const swiperConfig = {
      grabCursor: true,
      slidesPerView: 2.3,
      spaceBetween: 20,
      mousewheel: false,
      scrollbar: {
        el: carousel.querySelector('.swiper-scrollbar'),
        draggable: true,
        hide: false,
      },
      breakpoints: {
        1024: {
          slidesPerView: 3.6,
        },
      },
    };

    /* eslint-disable no-unused-vars */
    const swiper = new Swiper(carousel, swiperConfig);
  });

  /**
   * Init Swiper for ecommerce section
   */
  document.querySelectorAll('.js-pe-ecommerce-carousel').forEach((carousel) => {
    const swiperConfig = {
      grabCursor: true,
      slidesPerView: 2.4,
      spaceBetween: 20,
      mousewheel: false,
      navigation: {
        nextEl: carousel.parentElement.parentElement.querySelector('.swiper-button-next'),
        prevEl: carousel.parentElement.parentElement.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: carousel.parentElement.parentElement.querySelector('.swiper-pagination'),
        clickable: true,
        dynamicBullets: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 6,
        },
      },
    };

    /* eslint-disable no-unused-vars */
    const swiper = new Swiper(carousel, swiperConfig);
  });

  /**
   * Init Swiper for recipes
   */
  document.querySelectorAll('.js-pe-recipes-carousel').forEach((carousel) => {
    const swiperConfig = {
      grabCursor: true,
      slidesPerView: 1.5,
      spaceBetween: 20,
      mousewheel: false,
      navigation: {
        nextEl: carousel.parentElement.parentElement.querySelector('.swiper-button-next'),
        prevEl: carousel.parentElement.parentElement.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: carousel.parentElement.parentElement.querySelector('.swiper-pagination'),
        clickable: true,
        dynamicBullets: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 5,
        },
      },
    };

    /* eslint-disable no-unused-vars */
    const swiper = new Swiper(carousel, swiperConfig);
  });
});
